export class RestoreEksNamespaceVolumeInput {
    'providerVolumeId';
    'tags';
    'volumeEncryptionKeyId';
    'encryptionKeyId';
    'volumeSettings';
    'availabilityZone';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerVolumeId",
            "baseName": "providerVolumeId",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "volumeEncryptionKeyId",
            "baseName": "volumeEncryptionKeyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "encryptionKeyId",
            "baseName": "encryptionKeyId",
            "type": "string",
            "format": ""
        },
        {
            "name": "volumeSettings",
            "baseName": "volumeSettings",
            "type": "VolumeSettings",
            "format": ""
        },
        {
            "name": "availabilityZone",
            "baseName": "availabilityZone",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreEksNamespaceVolumeInput.attributeTypeMap;
    }
    constructor() {
    }
}
